"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FuseShortcutsModule {
}
exports.FuseShortcutsModule = FuseShortcutsModule;
